import { push } from "svelte-spa-router";

export default function consoler() {
    console.log('tester')
};

export async function postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
    });
    return response.json();
}

export function isJson(str) {
    if(str===null || str==='null') return false;
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function object2array(objecto)
{
  let datagridtmp=[];
  for(var mydata in objecto) {
      datagridtmp=[...datagridtmp,objecto[mydata]]
  }
  return datagridtmp;
}

export function vacio(texto)
{
    
    if(texto==null) return '<span class="text-secondary">[Vacio]</span>';
    if(texto.trim()=='')
    {
        return '<span class="text-secondary">[Vacio]</span>';
    } else {
        return texto;
    }
}

export function number(number)
{
    if(number===null) return 0;
    return parseInt(number);
}

export function moneda(number, moneda)
{
    if(number===null) return moneda+(0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneda+parseFloat(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function moneda4(number, moneda)
{
    if(number===null) return moneda+(0).toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneda+parseFloat(number).toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function redondeo4(number)
{
    return parseFloat(number).toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function verifyAccess(login,permiso,section,access)
{
    if(login===false) { 
        push('/login') 
    } else if(permiso[section][access]===false) { 
        push('/sinpermiso') 
    }
}

export function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

// use: sleep(2000).then(() => { console.log("World!"); });
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function uniqueid() {
    return 'UUID'+Math.floor(new Date().valueOf() * Math.random());
}

export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
  
/*export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
  
    if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }
  
    return mergeDeep(target, ...sources);
}*/

export const mergeDeep = (target, source, isMergingArrays = false) => {
    target = ((obj) => {
        let cloneObj;
        try {
            cloneObj = JSON.parse(JSON.stringify(obj));
        } catch(err) {
            // If the stringify fails due to circular reference, the merge defaults
            //   to a less-safe assignment that may still mutate elements in the target.
            // You can change this part to throw an error for a truly safe deep merge.
            cloneObj = Object.assign({}, obj);
        }
        return cloneObj;
    })(target);

    const isObject = (obj) => obj && typeof obj === "object";

    if (!isObject(target) || !isObject(source))
        return source;

    Object.keys(source).forEach(key => {
        const targetValue = target[key];
        const sourceValue = source[key];

        if (Array.isArray(targetValue) && Array.isArray(sourceValue))
            if (isMergingArrays) {
                target[key] = targetValue.map((x, i) => sourceValue.length <= i
                                                            ? x 
                                                            : mergeDeep(x, sourceValue[i], isMergingArrays));
                if (sourceValue.length > targetValue.length)
                    target[key] = target[key].concat(sourceValue.slice(targetValue.length));
            } else {
                target[key] = targetValue.concat(sourceValue);
            }
        else if (isObject(targetValue) && isObject(sourceValue))
            target[key] = mergeDeep(Object.assign({}, targetValue), sourceValue, isMergingArrays);
        else
            target[key] = sourceValue;
    });

    return target;
};

export let IsPar=function(value)
{
    if (value%2==0) {
        return true;
    
    } else {
        return false;
    }
}

export function accordion(node, isOpen) {
    let initialHeight = node.offsetHeight;
    node.style.height = isOpen ? 'auto' : 0;
    node.style.overflow = "hidden";
    return {
        update(isOpen) {
            let animation = node.animate(
                [
                    {
                        height: initialHeight + 'px',
                        overflow: 'hidden'
                    },
                    {
                        height: 0,
                        overflow: 'hidden'
                    }
                ],
                { duration: 100, fill: 'both' }
            );
            animation.pause();
            if (!isOpen) {
                animation.play();
            } else {
                animation.reverse();
            }
        }
    };
}